import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { GET_VIMEO_ID, GET_YOUTUBE_ID, GET_PROVIDER } from './constants';

const useStyles = makeStyles(theme => ({
  embed: {
    minHeight: 500,
  },
  noInteraction: {
    pointerEvents: 'none',
  },
}));

const getEmbedSrc = (provider, src) => {
  switch (provider) {
    case 'youtube':
      return `https://youtube.com/embed/${GET_YOUTUBE_ID(src)}?rel=0`;
    case 'vimeo':
      return `https://player.vimeo.com/video/${GET_VIMEO_ID(src)}`;
    case 'soundcloud':
      return `https://w.soundcloud.com/player/?url=${src}&amp;auto_play=false&amp;hide_related=true&amp;show_comments=false&amp;show_user=true&amp;show_reposts=false&amp;visual=true`;
    case 'yumpu':
    default:
      return src;
  }
};

const Embed = props => {
  const classes = useStyles();
  const { src, noInteraction } = props;
  const provider = GET_PROVIDER(src);
  const embedSrc = getEmbedSrc(provider, src);
  return (
    <iframe
      src={embedSrc}
      className={cx(classes.embed, { [classes.noInteraction]: noInteraction })}
      width="100%"
      height="100%"
      minHeight={500}
      frameBorder="0"
      scrolling="0"
      allowFullScreen
    />
  );
};

Embed.propTypes = {
  src: PropTypes.string.isRequired,
};

export default Embed;
